import { useContext, useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { fakeTableList } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkButton from "../../components/atoms/TkButton";
import { BusinessContext } from "../../context/businessContext";
import { httpAPI_RET012 } from "./api/request";
import "./_style.scss";
import { labelids } from "../../assets/data/TkExplanationProperty";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";

/**
 * SCRR411118 合算制度利用申出の手続き
 * @return SCRR411118 合算制度利用申出の手続き
 */
const SCRR411118 = () => {
  const navigate = useNavigate();

  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  //業務用Contextを更新するState
  const { state: businessState } = useContext(BusinessContext);
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);
  const stateFakeTableListCp = useRef(_.cloneDeep(fakeTableList));

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRouterState({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerState.routerList]);

  const handleInit = async () => {
    try {
      const res = await httpAPI_RET012({
        contractorNo:
          state?.authInfo?.userType === authorityUserType?.userTypeNumber?.KIKO
            ? businessState?.common?.contractorNo!
            : state?.authInfo?.contractorNo!,
        staffNo: businessState?.job_36?.staffNo!,
        applyId: businessState.job_36?.applyId!,
        businessType: businessState.common?.businessType!,
      });

      let resArr = stateFakeTableListCp.current;
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        if (
          state?.authInfo?.userType ===
            authorityUserType?.userTypeNumber?.KIKO ||
          state?.authInfo?.userType ===
            authorityUserType?.userTypeNumber?.KEIYAKUSYA
        ) {
          let staff = resArr.find((item) => item.keyword === "staff")!;
          staff.showLine = true;
          staff.text =
            (businessState?.job_36?.staffNo ?? "") +
            ":" +
            (businessState?.job_36?.staffName ?? "");
        }

        resArr.find((item) => item.keyword === "limitationDate")!.text =
          res.limitationDate;
        resArr.find((item) => item.keyword === "transferCd")!.text =
          res.transferCd;
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
      setStateFakeTableList([...resArr]);
    } catch (error) {
      navigate("/error");
    }
  };

  const handleClick = () => {
    if (
      state?.authInfo?.userType ===
      authorityUserType?.userTypeNumber?.KEIYAKUSYA
    ) {
      navigate("/SCRC020001");
    } else {
      navigate("/SCRW110001");
    }
  };

  return (
    <Box className="SCRR411118" data-testid="SCRR411118PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLR411118_01}</TkInfoManual>
      <TkFakeTable
        list={stateFakeTableList}
        ruleSchema={{}}
        showButton={false}
      />

      {state?.authInfo?.userType === authorityUserType?.userTypeNumber?.KIKO ||
      state?.authInfo?.userType ===
        authorityUserType?.userTypeNumber?.KEIYAKUSYA ? (
        <TkButton className="btnMiddle" onClick={handleClick}>
          ホームへ戻る
        </TkButton>
      ) : null}
    </Box>
  );
};

export default SCRR411118;
